import * as helpers from './helpers.js';

export const MAKRET_SLUG = 'orlando-fl';
export const RESULTS_PER_PAGE = 12;
export const MATCH_TYPE = 'i';
export const SORT_BY = 'match-count';
export const SELECTED_STATE = 'FL';
export const LOCATION_FILTER = 'markets';
export const BASE_URL = helpers.getBaseURL();